import { useNavigate } from "react-router-dom";
import { MediaUri } from "../../constants/enum";
import BadgeProductStatus from "../../components/BadgeProductStatus";
import ButtonPillBrand from "../../components/ButtonPillBrand";
import { formatDistanceToNow, differenceInDays } from "date-fns";

function Card({ data }: any) {
  const navigate = useNavigate();
  let cardImage = "";
  const cardImages = data.images ? JSON.parse(data.images) : [];

  if (cardImages && cardImages.length > 0) {
    cardImage = `${MediaUri}/display/${cardImages[0]}`;
  }
  const updatedDateText = formatDistanceToNow(new Date(data.updatedAt));
  const diff = differenceInDays(new Date(data.updatedAt), new Date());

  return (
    <div className="flex justify-center">
      <div className="relative block max-w-sm bg-white rounded-lg shadow-lg dark:bg-neutral-700">
        <div className="absolute -right-0 -top-3">
          {diff ? (
            <span className=" inline-block whitespace-nowrap rounded-[0.27rem] bg-primary-100 px-[0.65em] pb-[0.25em] pt-[0.35em] text-center align-baseline text-[0.75em] font-bold leading-none text-primary-700">
              {updatedDateText} ago
            </span>
          ) : (
            <span className="animate-bounce inline-block whitespace-nowrap rounded-[0.27rem] bg-danger-100 px-[0.65em] pb-[0.25em] pt-[0.35em] text-center align-baseline text-[0.75em] font-bold leading-none text-danger-700">
              New
            </span>
          )}
        </div>

        <a
          href={`/product/${data.id}/show`}
          data-te-ripple-init
          data-te-ripple-color="light"
        >
          <img
            className="object-contain h-48 mt-4 rounded-t-lg w-96"
            src={cardImage ? cardImage : "/brands/no_image.png"}
            alt={data.name}
            onError={(e: any) => {
              e.target.src = "/brands/no_image.png";
            }}
          />
        </a>
        <div className="p-6">
          <h5 className="mb-2 text-lg font-medium leading-tight truncate text-neutral-800 dark:text-neutral-50">
            {data.name ? data.name : "-"}
          </h5>
          <div className="flex flex-row justify-start gap-2 mb-2">
            <ButtonPillBrand brand={data.brand} textSize="text-xs" />
            <BadgeProductStatus status={data.status} textSize="text-xs" />
          </div>
          <div className="flex flex-row justify-between text-xs">
            <span className="mb-4 font-bold text-neutral-600 dark:text-neutral-200">
              Mat. Code
            </span>
            <span className="font-bold">
              {data.materialCode ? data.materialCode : "-"}
            </span>
          </div>

          <div className="flex flex-row justify-between text-xs font-bold">
            <span className="mb-4 text-neutral-600 dark:text-neutral-200">
              Bar Code
            </span>
            <span className="font-bold">
              {data.barcode ? data.barcode : "-"}
            </span>
          </div>

          <div className="flex flex-row justify-between text-xs font-bold">
            <span className="mb-4 text-neutral-600 dark:text-neutral-200">
              Hierachy
            </span>
            <span className="font-bold">
              {data.productHierachy ? data.productHierachy : "-"}
            </span>
          </div>

          <div className="overflow-x-hidden">
            <span className="text-xs truncate text-neutral-600 dark:text-neutral-200">
              {data.titleEN ? data.titleEN : "-"}
            </span>
          </div>

          <div className="overflow-x-hidden">
            <span className="text-xs truncate text-neutral-600 dark:text-neutral-200">
              {data.titleTH ? data.titleTH : "-"}
            </span>
          </div>

          <br />

          <div className="flex flex-row justify-center">
            <button
              type="button"
              className="inline-block rounded bg-primary px-6 pt-2.5 pb-2 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)]"
              data-te-ripple-init
              data-te-ripple-color="light"
              onClick={() => {
                navigate(`/product/${data.id}/show`);
              }}
            >
              go to product
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Card;
